import { modulesListMockHandler } from '@/features/assessments';
import {
  getRecommendedQuizzesMockHandler,
  generateRoomMockHandler,
  getLeaderBoardMockHandler,
  getModuleDetailMockHandler,
  getModuleAssessmentSummaryMockHandler,
  getTopicAssessmentSummaryMockHandler,
  getQuizAttemptSummaryMockHandler,
} from '@/features/assessments/api';

export const assessmentsHandlers = [
  modulesListMockHandler,
  getRecommendedQuizzesMockHandler,
  generateRoomMockHandler,
  getLeaderBoardMockHandler,
  getModuleDetailMockHandler,
  getModuleAssessmentSummaryMockHandler,
  getTopicAssessmentSummaryMockHandler,
  getQuizAttemptSummaryMockHandler,
];
